module.exports = __webpack_public_path__ + "assets/img/tab3_01.01af9c60.jpg";